import React from 'react'
import { useSelector } from 'react-redux'

const OrderInformation = ({ dataDetail, distributionStatus }) => {
  const { order_detail_contact } = useSelector((state) => state.order)

  const paymentMethod = [
    { paymentMethod: 'credit', text: 'クレジットカード' },
    { paymentMethod: 'invoice', text: 'インボイス' },
    { paymentMethod: 'bank_transfer', text: '銀行振込' },
     { paymentMethod: 'np_kakebarai', text: 'NP掛け払い' },
    { paymentMethod: 'cvs', text: 'コンビニ決済' },
    { paymentMethod: 'pay_easy', text: 'ペイイージー' },
    { paymentMethod: 'points', text: 'ポイント' },
  ]

  const cvsOptions = [
    { cvsCode: '00007', cvsName: 'セブンイレブン' },
    { cvsCode: '00001', cvsName: 'ローソン' },
    { cvsCode: '00002', cvsName: 'ファミリーマート' },
    { cvsCode: '00005', cvsName: 'ミニストップ' },
    { cvsCode: '00008', cvsName: 'セイコーマート' },
    { cvsCode: '00006', cvsName: 'デイリーヤマザキ' },
  ]

  const textPattern = (pattern) => {
    if (pattern === 1) {
      return '全商圏共通版'
    } else if (pattern === 2) {
      return '全商圏別版'
    } else {
      return '商圏毎で版選択'
    }
  }

  return (
    <div className="w-full w-12/12 flex flex-col sm:flex-row gap-0 sm:gap-2">
      {/* Left */}
      <div className="order__detail w-12/12 sm:w-6/12 flex flex-col">
        <table className="w-[100%] text-left text-sm md:text-base">
          <tbody className="">
            <tr>
              <td
                colSpan="2"
                className="bg-primary bg-opacity-50 font-bold border-[1px] border-black px-2 py-[4px]"
              >
                お客様情報
              </td>
            </tr>
            <tr>
              <td className="font-bold">お客様会社名</td>
              <td>{dataDetail?.extra?.company?.name}</td>
            </tr>
            <tr>
              <td className="font-bold">お客様ID</td>
              <td>{dataDetail?.user_id}</td>
            </tr>
            <tr>
              <td className="w-[50%] font-bold border-[1px] border-black px-2 py-[4px]">
                顧客コード
              </td>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px]">
                {dataDetail?.extra?.customer_code}
              </td>
            </tr>
            <tr>
              <td className="font-bold"> チラシの名称</td>
              <td>{dataDetail?.extra?.ref_text}</td>
            </tr>
            <tr>
              <td className="w-[50%] font-bold border-[1px] border-black px-2 py-[4px]">
                電話 番号 1
              </td>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px]">
                {order_detail_contact?.value?.user_tel_no}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] font-bold border-[1px] border-black px-2 py-[4px]">
                電話 番号 2
              </td>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px]">
                {order_detail_contact?.value?.company_tel_no}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* End Left */}

      {/* Right */}
      <div className="order__detail w-12/12 sm:w-6/12 mt-8 sm:mt-0">
        <table className="w-[100%] text-left text-sm md:text-base">
          <tbody className="">
            <tr>
              <td
                colSpan="2"
                className="bg-primary bg-opacity-50 font-bold border-[1px] border-black px-2 py-[4px]"
              >
                注文情報
              </td>
            </tr>
            <tr>
              <td className="font-bold">注文日時</td>
              <td>{dataDetail?.created_at}</td>
            </tr>
            <tr>
              <td className="font-bold">原稿アップロード期限日</td>
              <td>{dataDetail?.extra?.upload_limit_date}</td>
            </tr>
            <tr>
              <td className="font-bold">折込日時</td>
              <td>{dataDetail?.insertion_date}</td>
            </tr>
            <tr>
              <td className="font-bold">部数</td>
              <td>{dataDetail?.estimation?.quantity}</td>
            </tr>
            <tr>
              <td className="font-bold">単価</td>
              <td>{dataDetail?.estimation?.unit_price?.toFixed(2)}</td>
            </tr>
            <tr>
              <td className="font-bold">注文ステイタス</td>
              <td>
                {distributionStatus?.map(
                  (status, idx) => idx === dataDetail?.status && status,
                )}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                支払い方法
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail?.extra?.payment?.method !== 'invoice' &&
                  paymentMethod.map(
                    (pm, i) =>
                      pm.paymentMethod ===
                        dataDetail?.extra?.payment?.method && (
                        <span key={i} className="mr-2">
                          {pm.text}
                        </span>
                      ),
                  )}
                {dataDetail?.extra?.payment?.method === 'cvs'
                  ? cvsOptions.map(
                      (co, i) =>
                        co.cvsCode ===
                          dataDetail?.extra?.payment?.convenience_code && (
                          <span key={i} className="">
                            {'  '}({co.cvsName})
                          </span>
                        ),
                    )
                  : null}
              </td>
            </tr>
            {dataDetail?.extra?.payment?.method !== 'np_kakebarai' ? (
              <tr>
                <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                  支払状態
                </td>
                <td className="w-[50%] border-[1px] border-black px-2">
                  {dataDetail?.estimation?.extra?.payment?.paid === 1
                    ? '支払済み'
                    : '未払い'}
                </td>
              </tr>
            ) : (
              <tr></tr>
            )}
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                処理結果
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail?.extra?.payment?.method === 'np_kakebarai'
                  ? dataDetail?.extra?.payment?.np_status_admin === ''
                    ? '-'
                    : dataDetail?.extra?.payment?.np_status_admin
                  : dataDetail?.extra?.payment?.status}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                支払期限
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail?.payment_limit_date}
              </td>
            </tr>
            <tr>
              <td className="font-bold">支払日</td>
              <td>
                {dataDetail?.extra?.payment?.paid === 1
                  ? dataDetail?.extra?.payment?.payment_date
                  : '未払い'}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                一括注文
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail.extra.bulk_type_id ? 'はい' : 'いいえ'}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                一括注文パターン
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail.extra.bulk_type_id
                  ? textPattern(dataDetail.extra.bulk_type_id)
                  : '--'}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                一括注文サブグループ
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail.extra.sub_group_id
                  ? 'パターンタイプ　' + dataDetail.extra.sub_group_id
                  : '--'}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
                お手元送付分
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail.for_direct_delivery
                  ? dataDetail.for_direct_delivery
                  : '--'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* End Right */}
    </div>
  )
}

export default OrderInformation
